// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2i6uQ","title":"Images90_title__1YvBl","images":"Images90_images__3cPoI"};